import { CTA, Breakpoints, Layout, styled } from '@volkswagen-onehub/components-core';
import { ChevronDown, ChevronUp } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { useTrackingManager } from 'src/feature-app/hooks';
import { Model } from 'src/feature-app/tracking-types';

interface EquipamientoContainerProps {
  activeEquipment: boolean;
}

const EquipamientoContainer = styled.div<EquipamientoContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: ${(props) => (props.activeEquipment ? '44px' : '12px')};
  padding-bottom: 6px;
`;

const Bar = styled.div`
  height: 2px;
  width: 100%;
  background-color: #dfe4e8;
  @media screen and (max-width: 559px) {
    display: none;
  }
`;

interface ButtonWrapperProps {
  activeEquipment: boolean;
}

const ButtonWrapper = styled.div<ButtonWrapperProps>`
  margin: 0 16px;
  width: ${(props) => (props.activeEquipment ? '180px' : '165px')};

  & > button {
    width: ${(props) => (props.activeEquipment ? '180px' : '165px')};

    & > div {
      top: 0 !important;
    }
  }
`;

interface MoreEquipmentButtonProps {
  numberOfOffers: number;
  activeEquipment: boolean;
  model: Model;
  setActiveEquipment: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MoreEquipmentButton = (props: MoreEquipmentButtonProps) => {
  const { numberOfOffers, activeEquipment, setActiveEquipment, model } = props;
  const trackingManager = useTrackingManager();

  const trackVehicleLink = () => {
    trackingManager.trackOffersVehicleLinkClick(model, { contentId: 'Ver equipamiento' });
  };

  return (
    <Layout
      appearance={{
        [Breakpoints.default]: [{ name: 'a', columns: 24 }],
        [Breakpoints.b960]: [
          { name: '.', columns: 2 },
          { name: 'a', columns: 20 },
          { name: '.', columns: 2 },
        ],
      }}
    >
      {numberOfOffers > 1 ? (
        <EquipamientoContainer activeEquipment={activeEquipment}>
          <Bar />
          <ButtonWrapper activeEquipment={activeEquipment}>
            <CTA
              tag="button"
              emphasis="secondary"
              size="small"
              onClick={() => {
                trackVehicleLink();
                setActiveEquipment(!activeEquipment);
              }}
              icon={!activeEquipment ? <ChevronDown variant="small" /> : <ChevronUp variant="small" />}
            >
              {!activeEquipment ? 'Ver equipamiento' : 'Cerrar equipamiento'}
            </CTA>
          </ButtonWrapper>
          <Bar />
        </EquipamientoContainer>
      ) : null}
    </Layout>
  );
};
